import {VEHICLE_TYPE} from '../actions/types';

const INITIAL_STATE = {
  vehicle: null,
  debtTripVehicleType : '' , 
  reserveId: null,
  tripId: null,
  reservetime: null,
  stop: false,
  money: 0,
  refresh: false,
  fr: true,
  reportst: false,
  activeSeconds: 0,
  pauseSeconds: 0,
  activeMinutes: 0,
  pauseMinutes: 0,
  adminCommand: null, // دستور ادمین برای کنترل سفر
};

const Vehicle = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case VEHICLE_TYPE:
      return {
        ...state,
        ...action.payload,
         money:
          action.payload.money !== undefined
            ? action.payload.money
            : state.money,
      };
    default:
      return state;
  }
};

export default Vehicle;
